import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from "@angular/core";
import { Observable, Subject, BehaviorSubject } from "rxjs";
import { Files } from "src/app/miscellaneous/files";

@Component({
  selector: "app-file-list",
  templateUrl: "./file-list.component.html",
  styleUrls: ["./file-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileListComponent implements AfterViewInit, OnDestroy {

  data!: any;

  private _files$ = new BehaviorSubject<any[]>([]);
  get files$(): Observable<any[]> {
    return this._files$.asObservable();
  }

  groupedFilesByCategory: {
    [category: string]: {
      description?: string;
      files: any[];
    };
  } = {};

  categoryList: {
    name: string;
    description?: string;
  }[] = [];

  originalFileList: any[] = [];
  props: any;

  page = 1;
  pageSize = 5;
  paginatedFiles: any[] = [];

  categoryNames: string[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private fileService: Files
  ) { }

  ngAfterViewInit(): void {
    if (this.data) {
      this.originalFileList = [...this.data.data];
      this._files$.next([...this.originalFileList]);
      this.props = this.data.props;

      if (this.props?.endpointCategories) {
        this.groupedFilesByCategory =
          this.groupFilesByCategory(this.originalFileList);

        this.categoryList = Object.keys(this.groupedFilesByCategory).map(key => ({
          name: key,
          description: this.groupedFilesByCategory[key]?.description
        }));
      }
    }

    if (this.props?.elementsToShow) {
      this.pageSize = this.props.elementsToShow;
      this.setPaginatedFiles();
    }

    this.cdr.detectChanges();
  }

  groupFilesByCategory(files: any[]): {
    [category: string]: { description?: string; files: any[] }
  } {
    const grouped: {
      [key: string]: { description?: string; files: any[] }
    } = {};

    files.forEach(file => {
      const categoryObj = file.categories?.[0];
      const categoryName =
        categoryObj?.name?.trim() || "Senza categoria";
      const categoryDescription = categoryObj?.description;

      if (!grouped[categoryName]) {
        grouped[categoryName] = {
          description: categoryDescription,
          files: []
        };
      }

      grouped[categoryName].files.push(file);
    });

    return grouped;
  }

  getPaginatedFilesByCategory(category: string): any[] {
    const files = this.groupedFilesByCategory[category]?.files ?? [];
    const startIndex = (this.page - 1) * this.pageSize;
    return files.slice(startIndex, startIndex + this.pageSize);
  }

  setPaginatedFiles(): void {
    const files = this._files$.getValue();
    const startIndex = (this.page - 1) * this.pageSize;
    this.paginatedFiles = files.slice(startIndex, startIndex + this.pageSize);
  }

  onPageChange(page: number): void {
    this.page = page;
    this.setPaginatedFiles();
  }

  downloadFile(item: any) {
    this.fileService.download(this.props.endpoint, item.id, item.title);
  }

  showPreview(item: any) {
    this.fileService.preview(this.props.endpoint, item.id);
  }

  getFileTitle(item: any): string {
    const key = this.props?.keyTitle;
    return item[key];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}